export enum EnumTipoPedido {
    ENTREGA = 0,
    RETIRAR = 1,
    LOCAL = 2,
}